module.exports = __webpack_public_path__ + "static/media/ojmn.91bf5ab8.mp3";